import React, { useEffect, useState } from 'react';

const Toast = () => {
    const [toast, setToast] = useState({ type: '', message: '', visible: false });

    useEffect(() => {
        const showToast = (type, message) => {
            setToast({ type, message, visible: true });
            setTimeout(() => {
                setToast({ type: '', message: '', visible: false });
            }, 2000);
        };

        window.showToast = showToast;
    }, []);

    if (!toast.visible) return null;

    return (
        <div className={`custom-toast ${toast.type === 'error' ? 'toast-error' : 'toast-success'}`}>
            <div className="toast-body">{toast.message}</div>
        </div>
    );
};

export default Toast;
